export default __webpack_public_path__ + "static/media/lilian2.749e6c58.jpg";